import React, { memo, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
const MAX_FILE_SIZE = 5242880; // 5MB
function FileInput({ children, onSelect, onError, allowedExtensions = [], allowMultipleFiles = false, disabled, }) {
    const formRef = useRef(null);
    const inputRef = useRef(null);
    const { t } = useTranslation('specification');
    const openFileChooser = useCallback(() => {
        if (!inputRef.current)
            return;
        inputRef.current.value = '';
        inputRef.current.click();
    }, []);
    const isExtensionAllowed = useCallback((file) => {
        const ext = file.name.split('.');
        if ((allowedExtensions === null || allowedExtensions === void 0 ? void 0 : allowedExtensions.length) === 0)
            return true;
        if ((ext === null || ext === void 0 ? void 0 : ext.length) < 2)
            return false;
        const [extSuffix] = ext.slice(-1);
        return allowedExtensions === null || allowedExtensions === void 0 ? void 0 : allowedExtensions.includes(extSuffix);
    }, [allowedExtensions]);
    const isFileCorrect = useCallback((file) => {
        if (file.size > MAX_FILE_SIZE || !isExtensionAllowed(file)) {
            onError === null || onError === void 0 ? void 0 : onError(t('some_files_no_match'));
            return false;
        }
        return true;
    }, [isExtensionAllowed, onError, t]);
    const handleSelectFile = useCallback((e) => {
        const { files } = e.target;
        if ((files === null || files === void 0 ? void 0 : files.length) < 1 && !allowMultipleFiles)
            return;
        if (allowMultipleFiles) {
            const inputFiles = [...files];
            const correctFiles = inputFiles === null || inputFiles === void 0 ? void 0 : inputFiles.filter((file) => isFileCorrect(file));
            if (correctFiles.length > 0) {
                onSelect === null || onSelect === void 0 ? void 0 : onSelect(correctFiles);
            }
            else
                onError === null || onError === void 0 ? void 0 : onError(t('no_files_match'));
        }
        else {
            const [file] = files;
            if (isFileCorrect(file))
                onSelect === null || onSelect === void 0 ? void 0 : onSelect(file);
        }
    }, [allowMultipleFiles, onError, t, isFileCorrect, onSelect]);
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { className: "FileInput", ref: formRef },
            React.createElement("input", { type: "file", multiple: allowMultipleFiles, ref: inputRef, disabled: disabled, onChange: handleSelectFile, hidden: true })),
        children(openFileChooser)));
}
export default memo(FileInput);
